<template>
    <div>
        <div class="ticketing_queue_details">
            <br/>
            <CRow class v-if="bookingDet">
                <CCol>
                    <CCard class="box-shadow-card border-none p-0 overflow-hidden b-radius-10px">
                        <CCardHeader v-if="bookingDet.bookingDetails" class="pt-4 pb-4">
                            <CRow>
                                <CCol class="status-wrap  ">
                                    <!--                  "not-paid" for booking cancelled-->
                                    <!--                  "paid" for booking successful-->
                                    <!--                  "partial-paid" for booking pending-->
                                    <div :class="bookingDet.bookingDetails.orderStatus==7?'partial-paid':bookingDet.bookingDetails.orderStatus==10?'paid':'not-paid'"
                                         class=" d-flex align-items-center">
                                        <div class="dot">

                                        </div>
                                        <strong >{{bookingDet.bookingDetails.orderStatusString}}</strong>
                                    </div>
                                </CCol>

                                <CCol v-if="bookingDet.bookingDetails.orderID" class="text-right">
               <span class="white-space-pre gray-f">
                   {{$t('bookingDetail.reservationId')}}
               </span>
                                    <strong>
                                        {{bookingDet.bookingDetails.orderID}}
                                    </strong>
                                </CCol>
                            </CRow>
                        </CCardHeader>
                        <CCardBody v-if="bookingDet.bookingDetails">
                            <CRow>
                                <CCol v-if="bookingDet.bookingDetails.bookingDate" class="mt-1">
                                    <div class="d-flex">
                                        <div>
                                            <img src="@imgPath/img/svg/icons/calender-gray.svg" alt="" height="15px"
                                                 width="15px" class="mr-10px">
                                        </div>
                                        <div>
                                            <div class="white-space-pre gray-f">{{$t('bookingDetail.dateOfBooking')}}
                                            </div>

                                            <div class="mt-2">{{bookingDet.bookingDetails.bookingDate |
                                                formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                            </div>
                                        </div>

                                    </div>

                                    <br/>
                                </CCol>
                                <CCol v-if="bookingDet.bookingDetails&&bookingDet.bookingDetails.ticketingDeadline"
                                      class="mt-1">
                                    <div class="d-flex">
                                        <div>
                                            <img src="@imgPath/img/svg/icons/calender-gray.svg" alt="" height="15px"
                                                 width="15px" class="mr-10px">
                                        </div>
                                        <div>
                                            <div class="white-space-pre gray-f">
                                                {{$t('bookingDetail.ticketingDeadline')}}
                                            </div>
                                            
                                            <div class="mt-2">{{bookingDet.bookingDetails.ticketingDeadline |
                                               formatDateTimeTZ(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                            </div>
                                        </div>

                                    </div>

                                    <br/>
                                </CCol>

                                <CCol v-if="bookingDet.bookingDetails.ticketIssueDate" class="mt-1">
                                    <div class="d-flex">
                                        <div>
                                            <img src="@imgPath/img/svg/icons/calender-gray.svg" alt="" height="15px"
                                                 width="15px" class="mr-10px">
                                        </div>
                                        <div>
                                            <div class="white-space-pre gray-f">{{$t('bookingDetail.tcktIssueDate')}}</div>
                                            <div class="mt-2">{{bookingDet.bookingDetails.ticketIssueDate |
                                                formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                            </div>
                                        </div>
                                    </div>

                                    <br/>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol v-if="bookingDet.bookingDetails && bookingDet.bookingDetails.booked_agent" class="mt-1">
                                    <div class="flex">
                                        <div>
                                            <img src="@imgPath/img/svg/icons/user-gray.svg" alt="" height="15px"
                                                 width="15px" class="mr-10px">
                                        </div>
                                        <div>
                                            <div class="white-space-pre gray-f">{{$t('bookingDetail.bookedBy')}}</div>

                                          
                                            <div class="mt-2">{{bookingDet.bookingDetails.booked_agent}}</div>
                                        </div>

                                    </div>

                                    <br/>
                                </CCol
                                >

                          

                                 
                                <CCol  class="mt-1">
                                    <div  v-if="bookingDet.bookingDetails &&bookingDet.bookingDetails.totalAmount" class="d-flex">
                                        <div>
                                            <img src="@imgPath/img/svg/icons/gray-money.svg" alt="" height="15px"
                                                 width="15px" class="mr-10px scale-1-2">
                                        </div>
                                        <div v-if="bookingDet.bookingDetails &&bookingDet.bookingDetails.totalAmount">
                                            <div class="white-space-pre gray-f">{{$t('bookingDetail.amount')}}</div>
                                            <div class="mt-2">
                                             {{bookingDet.orderPaymentDetails && bookingDet.orderPaymentDetails.length!=0 && 
                                             bookingDet.orderPaymentDetails[0].currency ? bookingDet.orderPaymentDetails[0].currency :bookingDet.bookingDetails.currency}}
                                               <span v-if="bookingDet.orderPaymentDetails.length!=0 && bookingDet.orderPaymentDetails[0].currency">
                                                 {{bookingDet.bookingDetails.totalAmount |formatNumber(bookingDet.orderPaymentDetails[0].currency)}}
                                                 </span>
                                                 <span v-else>
                                                 {{bookingDet.bookingDetails.totalAmount }}
                                                 </span>
                                            </div>
                                        </div>

                                    </div>
                                </CCol>

                                <!-- <CCol v-else-if="paymentDetails"
                                      class="mt-1">
                                    <div class="d-flex">
                                        <div>
                                            <img src="@imgPath/img/svg/icons/gray-money.svg" alt="" height="15px"
                                                 width="15px" class="mr-10px scale-1-2">
                                        </div>
                                        <div v-if="paymentDetails.TotalAmount">
                                            <div class="white-space-pre gray-f">{{$t('bookingDetail.amount')}}</div>
                                            <div class="mt-2">
                                                {{paymentDetails.currency?paymentDetails.currency:null+' '}}
                                                {{paymentDetails.TotalAmount.toString()|formatNumber(paymentDetails.currency)}}
                                            </div>
                                        </div>

                                    </div>

                                </CCol> -->
                              
                            </CRow>
                            <CRow>
                                <CCol v-if="bookingDet.bookingDetails && bookingDet.bookingDetails.reference" class="mt-1">
                                    <div class="d-flex">
                                        <div>
                                            <img src="@imgPath/img/svg/icons/gray-reference.svg" alt="" height="15px"
                                                 width="15px" class="mr-10px">
                                        </div>
                                        <!-- <div>
                                            <div class="white-space-pre gray-f">{{$t('bookingDetail.amount')}}</div>
                                            <div>{{bookingDet.orderPaymentDetails[0].currency?bookingDet.orderPaymentDetails[0].currency:null+' '}}{{bookingDet.orderPaymentDetails[0].TotalAmount}}</div>
                                        </div> -->
                                        <div>
                                            <div class="white-space-pre gray-f">{{$t('bookingDetail.ref')}}</div>
                                            <div class="mt-2">{{bookingDet.bookingDetails.reference}}</div>
                                        </div>
                                        <div>

                                        </div>
                                    </div>

                  </CCol>
                     <CCol v-if="bookingDet.bookingDetails && bookingDet.bookingDetails.ticketed_user" class="mt-1">
                      <div class="d-flex">
                          <div>
                              <img src="@imgPath/img/svg/icons/user-gray.svg" alt="" height="15px" width="15px" class="mr-10px">
                          </div>
                          <div>
                              <div class="white-space-pre gray-f">{{$t('bookingDetail.ticketedUser')}}</div>
                              <div class="mt-2">{{bookingDet.bookingDetails.ticketed_user}}</div>
                          </div>
                      <div>

                      </div>
                      </div>

                                </CCol>
                            </CRow>

                        </CCardBody>
                    </CCard>

                    <CCard class="box-shadow-card border-none p-0 overflow-hidden b-radius-10px"
                           v-if="bookingDet.contactDetails">
                        <CCardHeader class="pt-4 pb-4">
                            <div>
                                <strong>{{$t('bookingDetail.contactDet')}}</strong>
                            </div>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol v-if="bookingDet.contactDetails.contactName">
                                    <div class="d-flex">
                                        <div>
                                            <img src="@imgPath/img/svg/icons/user-gray.svg" alt="" height="15px"
                                                 width="15px" class="mr-10px">
                                        </div>
                                        <div>
                                            <div class="white-space-pre gray-f">{{$t('bookingDetail.contactName')}}
                                            </div>
                                            <div class="mt-2">{{bookingDet.contactDetails.contactName }}</div>
                                        </div>
                                    </div>

                                    <br/>
                                </CCol>

                                <CCol v-if="bookingDet.contactDetails.email">
                                    <div class="d-flex">
                                        <div>
                                            <img src="@imgPath/img/svg/icons/emaill-gray.svg" alt="" height="15px"
                                                 width="15px" class="mr-10px">
                                        </div>
                                        <div>
                                            <div class="white-space-pre gray-f">{{$t('bookingDetail.emailId')}}</div>
                                            <div class="mt-2">{{bookingDet.contactDetails.email}}</div>
                                            <br/>
                                        </div>
                                    </div>


                                </CCol>

                                <CCol v-if="bookingDet.contactDetails.mobileNo">
                                    <div class="d-flex">
                                        <div>
                                            <img src="@imgPath/img/svg/icons/phone-gray.svg" alt="" height="15px"
                                                 width="15px" class="mr-10px">
                                        </div>
                                        <div>
                                            <div class="white-space-pre gray-f">{{$t('bookingDetail.contactNum')}}</div>
                                            <div class="mt-2">{{bookingDet.contactDetails.mobileCode}}
                                                {{bookingDet.contactDetails.mobileNo}}
                                            </div>
                                            <br/>
                                        </div>
                                    </div>

                                </CCol>
                            </CRow>

                        </CCardBody>
                    </CCard>

                    <CCard class="box-shadow-card border-none p-0 overflow-hidden b-radius-10px "
                           v-if="bookingDet && bookingDet.orderPaymentDetails[0] && bookingDet.orderPaymentDetails[0]!=undefined">
                        <CCardHeader class="pt-4 pb-4">
                            <div>
                                <strong>
                                    {{$t('bookingDetail.paymentDet')}}
                                </strong>
                            </div>
                        </CCardHeader>
                        <CCardBody class="pb-0">
                            <CRow>
                                <CCol>
                                    <div v-if="paymentDetails.transactionId" class="d-flex" >
                                        <div class="white-space-pre gray-f pr-2">{{$t('bookingDetail.transactionId')}}
                                        </div>
                                        <div class="w-100 text-ellipsis text-right" >{{paymentDetails.transactionId}}</div>

                                    </div>
<!--                                    <br v-if="paymentDetails && paymentDetails.transactionId"/>-->
                                    <br v-if="paymentDetails"/>

                                        <div class="d-flex" v-if="paymentDetails && paymentDetails.paymentType">
                                            <div class="white-space-pre gray-f pr-2">{{$t('bookingDetail.paymentType')}}
                                            </div>
                                            <div  class="w-100 text-ellipsis text-right">{{paymentDetails.paymentType}}</div>
                                        </div>

                                        <br v-if="paymentDetails"/>
                                    <div v-if="paymentDetails">
                                        <div class="d-flex" v-if="paymentDetails.approvalCode">
                                            <div class="white-space-pre gray-f pr-2">{{$t('bookingDetail.approvalCode')}}
                                            </div>
                                            <div class="w-100 text-ellipsis text-right">{{paymentDetails.approvalCode}}</div>
                                        </div>
                                    </div>


                                        <br v-if="paymentDetails.approvalCode"/>
                                    </CCol>


                                <CCol>
    <table class="payment-details">
        <tbody>
        <tr v-if="paymentDetails && paymentDetails.OrderAmount">
            <td><div class="white-space-pre gray-f ">{{$t('bookingDetail.bookingAmt')}}
                </div>

            </td>
            <td>

                    <div class="">{{paymentDetails.currency?paymentDetails.currency:null+' '}}
                    </div>


            </td>
            <td>
                <div v-if="paymentDetails.currency" class=" text-right">{{' '+paymentDetails.OrderAmount.toString()|formatNumber(paymentDetails.currency)}}
                </div>
                <div v-else class=" text-right">{{' '+paymentDetails.OrderAmount.toString()}}
                </div>
            </td>
        </tr>
        <tr v-if="paymentDetails && paymentDetails.PaymentFee">
            <td>
                <div class="white-space-pre gray-f ">{{$t('bookingDetail.paymentFee')}}
                </div>

            </td>
            <td>{{paymentDetails.currency?paymentDetails.currency:null+' '}}
            </td>
            <td v-if="paymentDetails.PaymentFee" class="d-flex justify-content-end">
                <span v-if="paymentDetails.currency" class=" text-right">
                  {{' '+paymentDetails.PaymentFee.toString()|formatNumber(paymentDetails.currency)}}
                  <!-- {{' '+paymentDetails.PaymentFee}} -->
                                        </span>
                <span v-else class=" text-right">
                  {{' '+paymentDetails.PaymentFee.toString()}}
                  <!-- {{' '+paymentDetails.PaymentFee}} -->
                                        </span>
            </td>
        </tr>
        <tr v-if="paymentDetails">
            <td v-if="paymentDetails.ExchangeFee" >
                <div >
                    <div class="white-space-pre gray-f ">{{$t('bookingDetail.exchangeFee')}}
                </div>

                </div>

            </td>
            <td v-if="paymentDetails.ExchangeFee" class="text-right">
                <div v-if="paymentDetails.currency" class="text-right">{{paymentDetails.ExchangeFee.toString()|formatNumber(paymentDetails.currency)}}</div>
                <div v-else class="text-right">{{paymentDetails.ExchangeFee.toString()}}</div>
            </td>
        </tr>
        <tr>
            <td>
                <hr>
            </td>
            <td>
                <hr>
            </td>
            <td>
                <hr>
            </td>
        </tr>
        <tr  v-if="paymentDetails">
            <td>
                <div class="white-space-pre gray-f">{{$t('bookingDetail.totalAmt')}}
                </div>
            </td>
            <td>
                <div class="white-space-pre ">{{paymentDetails.currency?paymentDetails.currency:null+' '}}
                </div>
            </td>
            <td v-if="paymentDetails.TotalAmount" class="d-flex justify-content-end">
              <div class="white-space-pre  text-right align-items-center d-flex">
                <strong v-if="paymentDetails.currency">
                 {{paymentDetails.TotalAmount.toString() | formatNumber(paymentDetails.currency)}}
            </strong>
             <strong v-else>
                 {{paymentDetails.TotalAmount.toString()}}
            </strong>
            </div>

            </td>
        </tr>
        </tbody>

    </table>
                                </CCol>
                            </CRow>





                        </CCardBody>
                        <div v-if="bookingDet.orderPaymentDetails.length>1"
                             @click="showPaymentHistory = !showPaymentHistory" class="c-pointer blue-text m-auto ml">
                        <span class="pr-3 ">
{{$t('bookingDetail.paymentHistory')}}
                        </span><img src="@imgPath/img/svg/icons/blue-icons/arrow-help.svg"
                                    :class="{'rotate-180 ' : showPaymentHistory}" height="7px"
                                    class="m-auto ml " alt="">
                        </div>
                        <br v-if="bookingDet.orderPaymentDetails.length>1"/>
                        <CCardBody
                                v-if="bookingDet.orderPaymentDetails && bookingDet.orderPaymentDetails.length>1 && showPaymentHistory">
                            <div v-for="(payments,pIndex) in bookingDet.orderPaymentDetails" :key="pIndex+'pay'"
                                 class="payment-history-wrap">
                                <CRow>
                                    <CCol>
                                        <div class="status-wrap ">

                                            <div :class="'indicate-dot-text ' +' '+getStatus(payments.status)"
                                                 class="d-flex align-items-center">
                                                <div class="dot">
                                                </div>
                                                <div>
                                                    <strong v-if=" getStatus(payments.status) == 'paid' && payments.status==BOOKING_STATUS.TICKETED_SUCCESS_STATUS">Success</strong>
                                                    <strong v-if=" getStatus(payments.status) == 'partial_paid' && payments.status==BOOKING_STATUS.HOLD_STATUS">Hold</strong>
                                                     <strong v-if=" getStatus(payments.status) == 'partial_paid' && payments.status==BOOKING_STATUS.PAYMENT_STATUS_PENDING">Payment Pending</strong>
                                                    <strong v-if=" getStatus(payments.status) == 'unpaid' && payments.status==BOOKING_STATUS.PAYMENT_FAILED">Failed</strong>
                                                </div>
                                            </div>


                                        </div>

                                        <div class="pl-25px">{{payments.transactionDate |
                                            formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                        </div>
                                        <br/>
                                    </CCol>
                                    <br/>

                                </CRow>
                                <CRow>
                                    <CCol md="1">

                                    </CCol>
                                    <CCol md="5">
                                        <div class="d-flex" v-if="payments && payments.transactionId">
                                            <div class="white-space-pre gray-f pr-2">
                                                {{$t('bookingDetail.transactionId')}}
                                            </div>
                                            <div>{{payments.transactionId}}</div>
                                        </div>

                                        <br v-if="payments && payments.transactionId"/>
                                            <div class="d-flex" v-if="payments && payments.paymentType">
                                                <div class="white-space-pre gray-f pr-2">
                                                    {{$t('bookingDetail.paymentType')}}
                                                </div>
                                                <div class="text-ellipsis">{{payments.paymentType}}</div>
                                            </div>

                                            <br v-if="payments && payments.paymentType"/>
                                        <div v-if="payments && payments.approvalCode">
                                            <div>{{$t('bookingDetail.approvalCode')}}</div>
                                            <div>{{payments.approvalCode}}</div>
                                            <br/>
                                        </div>
                                    </CCol>

                                    <CCol md="6" >
                                        <table class="payment-details payment-history-t">
                                            <tbody>
                                            <tr v-if=" payments&& payments.OrderAmount">
                                                <td>
                                                <div class="white-space-pre gray-f">
                                                        {{$t('bookingDetail.bookingAmt')}}
                                                </div>
                                                </td>
                                                <td>
                                                    <span class="pr-2 white-space-pre">{{payments.currency?payments.currency:null+' '}}</span>
                                                    
                                                </td>
                                                <td class="d-flex justify-content-end">
                                                    <span v-if="payments.currency" class=" text-right">
                                                    <!-- {{payments.OrderAmount}} -->
                                                    {{payments.OrderAmount.toString()|formatNumber(payments.currency)}}
                                                    </span>
                                                    <span v-else class=" text-right">
                                                    <!-- {{payments.OrderAmount}} -->
                                                    {{payments.OrderAmount.toString()}}
                                                    </span>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                <div class="white-space-pre gray-f">
                                                    {{$t('bookingDetail.paymentFee')}}
                                                </div>
                                                </td>
                                                <td>
                                                    <span class="pr-2 white-space-pre">{{payments.currency?payments.currency:null+' '}}</span>
                                                </td>
                                                <td class="d-flex justify-content-end">

                                                   <span v-if="payments.currency" class=" text-right d-flex justify-content-end ">
                        <!-- {{payments.PaymentFee}} -->
                       {{payments.PaymentFee.toString()|formatNumber(payments.currency)}}
                      </span>
                         <span v-else class=" text-right d-flex justify-content-end ">
                        <!-- {{payments.PaymentFee}} -->
                       {{payments.PaymentFee.toString()}}
                      </span>

                                                </td>
                                            </tr>
                                            <tr v-if="payments && payments.ExchangeFee">
                                                <td>
                                                    {{$t('bookingDetail.exchangeFee')}}
                                                </td>
                                                <td>

                                                </td>
                                                <td class="d-flex justify-content-end">
                                                    <span v-if="payments.currency" class=" text-right">
                                                    {{payments.ExchangeFee.toString()|formatNumber(payments.currency)}}
                                                    </span>
                                                    <span v-else class=" text-right">
                                                    {{payments.ExchangeFee.toString()}}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr><td><hr></td><td><hr></td><td><hr></td></tr>
                                            <tr v-if="payments">
                                                <td>
                                                    {{$t('bookingDetail.totalAmt')}}
                                                </td>
                                                <td>
                                                    {{payments.currency?payments.currency:null+' '}}
                                                </td>
                                                <td v-if="payments.TotalAmount" class="d-flex justify-content-end">
                                                    <span class=" text-right">
                                                     <strong v-if="payments.currency">
                                                      
                                                       {{payments.TotalAmount.toString()|formatNumber(payments.currency)}}
                                                       </strong>
                                                        <strong v-else>
                                                      
                                                       {{payments.TotalAmount.toString()}}
                                                       </strong>
                                                    </span> 
                                                </td>
                                            </tr>

                                            </tbody>
                                        </table>
                                    </CCol>
                                </CRow>



<!--                                <hr class="mb-3">-->
                            </div>
                        </CCardBody>
                    </CCard>

                </CCol>

                <CCol v-if="lsFlights && lsFlights.length">
                    <CCard class="box-shadow-card border-none p-0 overflow-hidden b-radius-10px"
                           v-for="(flights,index) in lsFlights " :key="'bookDet'+index">
                        <CCardBody>
                            <cFlightLegWithPax :isBooking="true" :flightObj="flights"
                                               :paxList="bookingDet"></cFlightLegWithPax>
                        </CCardBody>
                    </CCard>

                </CCol>
            </CRow>
             <div class="m-auto " v-if="alertValue">
                <br/>
                <br/>
                <CAlert show color="danger" class="d-flex">
                    <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                        <p class="pr-2"  v-for="(value,index) in alertValue.valueList" :key="index">
                            {{value}}
                        </p>
                    </div>
                    <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                        <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                    </div>
                    <div  v-if="alertValue&&alertValue.constructor==String">
                        <p  >
                            {{alertValue}}
                        </p>
                    </div>
                </CAlert>

            </div>
            <div class="card box-shadow-card border-none p-0 " v-if="!isLoading">
                <footer>
                    <div>
                        <CButton @click="navigateToPrevPage"
                                 class="btn align-right btn-lit-blue btn-success m-10px bg-danger">
                <span>
                        {{ $t('cTicketingDetail.goBackBtn') }}
                </span>
                        </CButton>
                    </div>
                    <div v-if="bookingDet" class="d-flex">
                        <CButton @click="onShowRetryPayModel(ticketObj)"
                                 v-if="AGENT_SIGNIN_RES&&!isBooking&&getRetryBtnStatus(bookingDet)"
                                 class="btn align-right btn-lit-blue btn-success m-10px ml-auto">
                <span>
                        {{ $t('cTicketingDetail.retryPayment') }}
                </span>
                        </CButton>
                        <CButton @click="navToTicketNowPage(ticketObj)"
                                 v-if="AGENT_SIGNIN_RES&&checkHoldByOrderStatus(bookingDet)&&!isBooking&&!getRetryBtnStatus(bookingDet)"
                                 class="btn align-right btn-lit-blue btn-success m-10px ml-auto">
                <span>
                        {{ $t('ticketingQueue.tcktNow') }}
                </span>
                        </CButton>
                        <CButton @click="navToTicketNowPage(ticketObj)"
                                 v-if="ADMIN_SIGNIN_RES&&checkHoldByOrderStatus(bookingDet)&&!isBooking&&!getRetryBtnStatus(bookingDet)"
                                 class="btn align-right btn-lit-blue btn-success m-10px ml-auto">
                <span>
                        {{ $t('ticketingQueue.tcktNow') }}
                </span>
                        </CButton>
                        <CButton @click.stop="onShowCancelConfirmation(ticketObj)"
                                 v-if="AGENT_SIGNIN_RES&&getCancelBtnStatus(bookingDet)"
                                 class="btn align-right btn-lit-blue btn-success m-10px bg-danger width-125px">
                <span>
                        {{ $t('ticketingQueue.cancelBtn') }}
                </span>
                        </CButton>

                        <button v-c-tooltip.hover=" {content:'Previous refund/exchange request pending'}"

                                v-if="isRequested && isBooking&&AGENT_SIGNIN_RES&&getRefundStatus(ticketObj)"
                                class="align-center btn-success m-10px ml-auto width-125px br-3px b-none">
                <span>
                        {{ $t('ticketingQueue.refund') }}
                </span>
                        </button>

                        <button
                                @click.stop="navToRefund(ticketObj)"
                                v-if="!isRequested && isBooking&&AGENT_SIGNIN_RES&&getRefundStatus(ticketObj)"
                                class="align-center btn-success m-10px ml-auto width-125px br-3px b-none">
                <span>
                        {{ $t('ticketingQueue.refund') }}
                </span>
                        </button>

                        <button
                                @click.stop="navToExchange(bookingDet)"
                                v-if="!isRequested && isBooking&&AGENT_SIGNIN_RES&&getExchangeStatus(ticketObj)"
                                class=" align-center btn-lit-blue btn-success m-10px ml-auto width-125px br-3px">
                <span>
                        {{ $t('ticketingQueue.exchange') }}
                </span>
                        </button>

                        <button v-c-tooltip.hover=" {content:'Previous refund/exchange request pending'}"

                                v-if="isRequested && isBooking&&AGENT_SIGNIN_RES&&getExchangeStatus(ticketObj)"
                                class="align-center btn-lit-blue btn-success m-10px ml-auto width-125px br-3px">
                <span>
                        {{ $t('ticketingQueue.exchange') }}
                </span>

                        </button>
                    </div>
                </footer>
            </div>
        </div>
        <cAlertModal v-if="isRetryPaymentAlert"
                     :buttonList="[{
              name:$t('ticketingQueue.noBtn'),func:onHideRetryModal,color:'danger'},
                {name:$t('ticketingQueue.yesBtn'),func:onRetryPayment,color:'success'},]"
                     :status="2"
                     :show="isRetryPaymentAlert"
                     :desc="[$t('ticketingQueue.retryPaymentModalDesc1'),$t('ticketingQueue.retryPaymentModalDesc2')]"
:key='2'
        ></cAlertModal>
        <cAlertModal v-if="isBookCancelledAlert"
                     :buttonList="[
                {name:$t('ticketingQueue.okBtn'),func:onHideCancelledAlert,color:'success'},]"
                     :status="1"
                     :show="isBookCancelledAlert"
                     :desc="[$t('ticketingQueue.cancelBookingSuccessdesc'),
            selBookingDetail.orderid?$t('ticketingQueue.reservationId')+': '+selBookingDetail.orderid:''
            ]"
:key='1'

        ></cAlertModal>

 <cAlertModal v-if="isBookCancelFailed"
         :buttonList="[
             {name:$t('ticketingQueue.okBtn'),func:onHideBookCancelFailed,color:'danger'},]"
        :status="0"
         :show="isBookCancelFailed"
         :desc="alertValue"
         :key='0'
       ></cAlertModal>
        <cAlertModal v-if="isShowCancelAlert"
                     :buttonList="[{
              name:$t('ticketingQueue.noBtn'),func:onRejectCancel,color:'danger'},
                {name:$t('ticketingQueue.yesBtn'),func:onCancelBooking,color:'success'},]"
                     :status="2"
                     :show="isShowCancelAlert"
                     :desc="$t('ticketingQueue.cancelConfirmation')"
                     :key="'showCancelConfirm'+2"

        ></cAlertModal>

         
    </div>



</template>

<script>
import {
  addClassToBody,
  removeClassBody,
  GroupByList,
  cloneDeep
} from "../../../../util/util";

import {
  COMPONENT_NAME,
  DATE_TIME_FORMAT,
  PATHNAME,
  ROUTER_PARAM,
  ORDER,
  TRIP,
  DEFAULT_DROPDOWN_STATUS,
  ALERT_MODAL_STATUS,
  BOOKING_STATUS,BOOKING_ORDER_TYPE,
  REFUND_SEGMENT_STATUS,
} from "../../../../util/constants";

    import apiCancelBooking from "../../../../services/apiCancelBooking";
import cTicketingQueue from "../../../../components/ticketing/cTicketingQueue";
import { mapGetters, mapActions } from "vuex";
import apiGetMyBookingsList from "../../../../services/apiGetMyBookingsList";
import apiGetOrderDetailsForViewNew from "../../../../services/apiGetOrderDetailsForViewNew";
import BaseConfiguration from "../../../../config/base";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  cloneData,
  removeDuplicates,
  OrderBy,
  OrderByList
} from "../../../../util/util";
import router, {navigate, goBack} from "../../../../router/index";
import Logger from "../../../../services/logger";
import { subDays } from "../../../../util/date/dateFunctions";
import cConnectingFlightInfo from "./../../../../components/result/cConnectingFlightInfo";
import cFlightLegWithPax from "./../../../../components/booking/flight/details/cFlightLegWithPax";
//import func from '../../../../../vue-temp/vue-editor-bridge';
    import cAlertModal from "./../../../../components/form/cAlertModal";
import Router from '../../../../router/index';

export default {
  name: COMPONENT_NAME.BOOKING_DETAILS,

  components: {
    cConnectingFlightInfo,
    cFlightLegWithPax,
    cAlertModal
  },

  data: () => {
    return {
      alertValue:null,
      selBookingDetail:null,
      isShowCancelAlert:false,
      isBookCancelFailed:false,
                isBookCancelledAlert:false,
      bookingDet: null,
      lsFlights: [],
      showPaymentHistory:false,
      paymentDetails:null,
      isRequested: false,
      isRetryPaymentAlert:false,
      BOOKING_STATUS:BOOKING_STATUS,
      isLoading:true,

    };
  },

  computed: {
    DATE_TIME_FORMAT() {
      return DATE_TIME_FORMAT;
    },
    ...mapGetters("sTicketingQueue", {
      ticketObj: "GET_TICKETING_QUEUE",
      isBooking: "GET_IS_BOOKING_STATUS"
    }),
      ...mapGetters("sSysLogin", {
                ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
            }),
            ...mapGetters("sAgtLogin", {
                AGENT_SIGNIN_RES: "GET_SIGNIN_RES"
            }),
            
  },

  methods: {
    ...mapActions("sCPaymentList", {
     SET_CURRENCY: "SET_CURRENCY"
    }),
      ...mapActions("cBookingDetail", {
                SET_TKT_REFUND_OBJ:"SET_TKT_REFUND_OBJ",
                SET_TKT_EXCHANGE_OBJ:"SET_TKT_EXCHANGE_OBJ"

            }),
             ...mapActions("sTicketingQueue", {
               SET_FLIGHT_INFO_STATUS: "SET_FLIGHT_INFO_STATUS",
     SET_TICK_QUEUE_REQ: "SET_TICK_QUEUE_REQ",
     SET_ORDER_ID: "SET_ORDER_ID"
    }),
      onRetryPayment() {
                try {
                  if(BaseConfiguration.isDebug) console.log("onRetryPayment");
               this.isRetryPaymentAlert=false;
               this.navToTicketNowPage(this.selBookingDetail)
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.BOOKING_DETAILS,
                          "error in onRetryPayment",
                          err.toString(),
                          "onRetryPayment",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                }, 
 onHideRetryModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onHideRetryModal");
                  
                    this.isRetryPaymentAlert = false;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.BOOKING_DETAILS,
                        "error in onHideRetryModal",
                        err.toString(),
                        "onHideRetryModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

              onRejectCancel() {
                try {
                    if(BaseConfiguration.isDebug) console.log("onRejectCancel");
                    this.isShowCancelAlert=false;
                    this.isBookCancelFailed=false;
                    this.isBookCancelledAlert=false;
                    this.isRetryPaymentAlert=false;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onRejectCancel",
                        err.toString(),
                        "onRejectCancel",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                },
                 onHideCancelledAlert() {
                try {
                    if(BaseConfiguration.isDebug) console.log("onHideCancelledAlert");
                    navigate(PATHNAME.MY_BOOKING)
                    this.isBookCancelledAlert=false;
                    
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onHideCancelledAlert",
                        err.toString(),
                        "onHideCancelledAlert",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            onHideBookCancelFailed() {
                try {
                    if(BaseConfiguration.isDebug) console.log("onHideBookCancelFailed");
                    // navigate(PATHNAME.MY_BOOKING)
                    this.isBookCancelFailed=false;
                    
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onHideBookCancelFailed",
                        err.toString(),
                        "onHideBookCancelFailed",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
    formatCurrency(pCurrency) {
                try {
                  if(BaseConfiguration.isDebug) console.log("formatCurrency");
                  let currency=null;
                  if(pCurrency){
                  if(pCurrency.constructor==Array){
                    for(let i=0;i<pCurrency.length;i++){
                      if(pCurrency[i].hasOwnProperty('currency_code')){
                        currency=pCurrency[i].currency_code.code;
                      }else if(pCurrency[i].hasOwnProperty('code')){
                        currency=pCurrency[i].code;
                      }
                    }
                  }else if(pCurrency.constructor==Object){
                     if(pCurrency.hasOwnProperty('currency_code')){
                        currency=pCurrency.currency_code.code;
                      }else if(pCurrency.hasOwnProperty('code')){
                        currency=pCurrency.code;
                      }
                  }else{
                    currency=pCurrency;
                  }

                }
                return currency;
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.BOOKING_DETAILS,
                          "error in formatCurrency",
                          err.toString(),
                          "formatCurrency",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  
                }, 


     navToRefund(pTicketObj)
    {
 
         try {
           if(BaseConfiguration.isDebug) console.log("navToRefund");

             if(!this.isRequested){    
            if(pTicketObj)
           {
          this.SET_TKT_REFUND_OBJ(pTicketObj);
          navigate(PATHNAME.REFUND)
           }
           else
           {
               throw 'Invalid Ticket Object '
           }
             }
           
         } catch (err) {
                 let body = Logger.buildRequest(
                   COMPONENT_NAME.BOOKING_DETAILS,
                   "error in navToRefund",
                   err.toString(),
                   "navToRefund",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
         
         
    },


     getRefundStatus(pTicket) {
         let retValue=false;

          try {
            if(BaseConfiguration.isDebug) console.log("getRefundStatus");


            if(pTicket && pTicket.status && pTicket.orderType==BOOKING_ORDER_TYPE.BOOKING_ORDER)
            {
             retValue= (pTicket.status==   BOOKING_STATUS.TICKETED_SUCCESS_STATUS);
             
            }


      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.BOOKING_DETAILS,
                    "error in getRefundStatus",
                    err.toString(),
                    "getRefundStatus",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 

           getExchangeStatus(pTicket) {
         let retValue=false;

          try {
            if(BaseConfiguration.isDebug) console.log("getExchangeStatus");


            if(pTicket && pTicket.status && pTicket.orderType==BOOKING_ORDER_TYPE.BOOKING_ORDER)
            {
             retValue= (pTicket.status==   BOOKING_STATUS.TICKETED_SUCCESS_STATUS) ;
             
            }


      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.BOOKING_DETAILS,
                    "error in getExchangeStatus",
                    err.toString(),
                    "getExchangeStatus",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 

           navToExchange(pTicketObj)
    {
 
         try {
           if(BaseConfiguration.isDebug) console.log("navToExchange");
           if(!this.isRequested){
           if(pTicketObj)
           {
          this.SET_TKT_EXCHANGE_OBJ(pTicketObj);
          navigate(PATHNAME.EXCHANGE)
           }
             else
           {
               throw 'Invalid Ticket Object '
           }
         }
         } catch (err) {
                 let body = Logger.buildRequest(
                   COMPONENT_NAME.BOOKING_DETAILS,
                   "error in navToExchange",
                   err.toString(),
                   "navToExchange",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
         
         
    },



    getCancelBtnStatus(pTicketItem) {
                let retValue;

                try {
                    if (BaseConfiguration.isDebug) console.log("getCancelBtnStatus");
                    if (pTicketItem && pTicketItem.bookingDetails.orderStatus) {
                        if (pTicketItem.bookingDetails.orderStatus == BOOKING_STATUS.HOLD_STATUS ||
                            pTicketItem.bookingDetails.orderStatus == BOOKING_STATUS.PAYMENT_STATUS_PENDING) {
                            retValue = true;
                        } else {
                            retValue = false;
                        }
                    } else {
                        retValue = false;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.BOOKING_DETAILS,
                        "error in getCancelBtnStatus",
                        err.toString(),
                        "getCancelBtnStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
    
    checkHoldByOrderStatus(pStatus) {
                try {
                    if (BaseConfiguration.isDebug) console.log("checkHoldByOrderStatus");
                    let retValue;
                    if (pStatus) {

                        if (pStatus.bookingDetails.orderStatus == BOOKING_STATUS.HOLD_STATUS)
                            retValue = true;
                        else
                            retValue = false;

                    }
                    return retValue;

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.BOOKING_DETAILS,
                        "error in checkHoldByOrderStatus",
                        err.toString(),
                        "checkHoldByOrderStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },
    
    getRetryBtnStatus(pTicketItem) {
                let retValue;

                try {
                    if (BaseConfiguration.isDebug) console.log("getRetryBtnStatus");
                    if (pTicketItem && pTicketItem.bookingDetails.orderStatus) {
                        if (pTicketItem.bookingDetails.orderStatus == BOOKING_STATUS.PAYMENT_STATUS_PENDING) {
                            retValue = true;
                        } else {
                            retValue = false;
                        }
                    } else {
                        retValue = false;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.BOOKING_DETAILS,
                        "error in getRetryBtnStatus",
                        err.toString(),
                        "getRetryBtnStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

         onShowCancelConfirmation(pItem) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onShowCancelConfirmation");
                    this.selBookingDetail = pItem;
                    this.isShowCancelAlert = true;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.BOOKING_DETAILS,
                        "error in onShowCancelConfirmation",
                        err.toString(),
                        "onShowCancelConfirmation",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
                  async onCancelBooking() {
                try {
                    if(BaseConfiguration.isDebug) console.log("onCancelBooking");

            //    if(pTicket && pTicket.status && pTicket.orderType==BOOKING_ORDER_TYPE.BOOKING_ORDER)
            //       {
            //  retValue= (pTicket.status==   BOOKING_STATUS.TICKETED_SUCCESS_STATUS) || (pTicket.status==BOOKING_STATUS.TICKET_PENDING);
             
            // }
                    let retCancelledbookRes= await this.getCancelBooking(this.selBookingDetail.orderId);
                    this.isShowCancelAlert=false;

                    if(retCancelledbookRes){
                        this.isBookCancelledAlert=true;
                        // this.onSearch();
                        //    await this.getTicketingQueueList(this.filterObject);
                    }else{
                        this.isBookCancelFailed=true;
                    }

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onCancelBooking",
                        err.toString(),
                        "onCancelBooking",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            async getCancelBooking(pOrderId) {
                let returnValue;
                try {
                    if(BaseConfiguration.isDebug) console.log("getCancelBooking");
                    let cancelBookingReq=  apiCancelBooking.buildRequest(pOrderId);
                    if(cancelBookingReq){
                        let cancelBookingRes= await apiCancelBooking.getResponse(cancelBookingReq);
                        //    let cancelBookingRes= {data:{"data":false,"status":"Success"}}
                        if (VALIDATE_SUCCESS_RES(cancelBookingRes)) {//VALIDATE_SUCCESS_RES(cancelBookingRes)
                            returnValue = cancelBookingRes.data.data;
                            this.alertValue = null;
                        } else {
                            let error = getErrorMessage(cancelBookingRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                               this.alertValue =  getErrorAlertValue(error,true,true);
                            }
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in getCancelBooking",
                        err.toString(),
                        "getCancelBooking",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;

            },
                onShowRetryPayModel(pItem) {
                try {
                    if(BaseConfiguration.isDebug) console.log("onShowRetryPayModel");
                    this.selBookingDetail=pItem;
                    this.isRetryPaymentAlert=true;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_TICKETING_QUEUE,
                        "error in onShowRetryPayModel",
                        err.toString(),
                        "onShowRetryPayModel",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },

    navToTicketNowPage(pTicketingDet) {
        try {
          if(BaseConfiguration.isDebug) console.log("navToTicketNowPage");
                    
          if(pTicketingDet){ 
            if(this.AGENT_SIGNIN_RES ){    
                 this.SET_TICK_QUEUE_REQ(pTicketingDet);

         this.SET_CURRENCY( this.formatCurrency(pTicketingDet.currency));

          

          
          
          navigate(PATHNAME.TICKET_NOW);
            }
         
          else if(this.ADMIN_SIGNIN_RES){
             this.SET_ORDER_ID(pTicketingDet.orderId)
            navigate(PATHNAME.SYSTEM_TICKET_NOW)
          }
          }
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.TICKETING_QUEUE_DETAIL,
                  "error in navToTicketNowPage",
                  err.toString(),
                  "navToTicketNowPage",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        },

    emitNav(item) {
                this.$emit("navFromDetail", item);
            },

     navigateToPrevPage() {
                try {
                    if (BaseConfiguration.isDebug) console.log("navigateToPrevPage");

                    goBack();
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.BOOKING_DETAILS,
                        "error in navigateToPrevPage",
                        err.toString(),
                        "navigateToPrevPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
    async getTicketingOrderDetails(ptcktObj) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getTicketingOrderDetails");
        if (ptcktObj) {
          let orderId = ptcktObj.orderId;

          let tcktRequest = apiGetOrderDetailsForViewNew.buildRequest(orderId);

          if (tcktRequest) {
            let tcktResponse = await apiGetOrderDetailsForViewNew.getResponse(
              tcktRequest
            );
            if (VALIDATE_SUCCESS_RES(tcktResponse)) {
              retValue = tcktResponse.data.data;
              this.SET_FLIGHT_INFO_STATUS(retValue.flights)
              // this.toggleShowTicketingDetail();
              this.alertVlaue = null;
            } else {
              let error = getErrorMessage(tcktResponse);
              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.alertVlaue = getErrorAlertValue(error);
              }
            }
          } else {
            throw "invalid request";
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.BOOKING_DETAILS,
          "error in getTicketingOrderDetails",
          err.toString(),
          "getTicketingOrderDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

     getStatus(pStatus) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getStatus");
                    let retValue;
                    
                        if (pStatus == BOOKING_STATUS.HOLD_STATUS) {
                            retValue = 'partial_paid'
                        } else if (pStatus == BOOKING_STATUS.TICKETED_SUCCESS_STATUS) {
                            retValue = 'paid'
                        } 
                        else if (pStatus == BOOKING_STATUS.PAYMENT_FAILED) {
                            retValue = 'unpaid'
                        }else if (pStatus == BOOKING_STATUS.PAYMENT_STATUS_PENDING) {
                            retValue = 'partial_paid'
                        }
                   
                    return retValue;

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_TICKETING_QUEUE,
                        "error in getStatus",
                        err.toString(),
                        "getStatus",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

    toGetStatusOfPax(pBookingDet) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("toGetStatusOfPax");
          if(pBookingDet){
            for (let i = 0; i < pBookingDet.length; i++) {
              if(pBookingDet[i].flightGroup[0]) {
                if(pBookingDet[i].flightGroup[0].type == 1){
                    if(pBookingDet[i].flightGroup[0].segmentStatus == BOOKING_ORDER_TYPE.BOOKING_ORDER) {
                      pBookingDet[i].flightGroup[0]["flightStatus"] = null;
                    }
                  }
                  if(pBookingDet[i].flightGroup[0].type == BOOKING_ORDER_TYPE.EXCHANGE){
                    if(pBookingDet[i].flightGroup[0].segmentStatus == REFUND_SEGMENT_STATUS.CHANGE_REQUESTED) {
                      pBookingDet[i].flightGroup[0]["flightStatus"] =  this.ADMIN_SIGNIN_RES ? this.$t('bookingDetail.newExchangeReq'):
                       this.$t('bookingDetail.exchangeReq');
                    }
                    else if(pBookingDet[i].flightGroup[0].segmentStatus == REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS) {
                      pBookingDet[i].flightGroup[0]["flightStatus"] = this.$t('bookingDetail.exchangeSuccess');
                    }
                    else if(pBookingDet[i].flightGroup[0].segmentStatus == REFUND_SEGMENT_STATUS.FULFILLED_FAILURE) {
                      pBookingDet[i].flightGroup[0]["flightStatus"] = this.$t('bookingDetail.exchangeFail');
                    }
                  }
                  if(pBookingDet[i].flightGroup[0].type == BOOKING_ORDER_TYPE.REFUND){
                    if(pBookingDet[i].flightGroup[0].segmentStatus == REFUND_SEGMENT_STATUS.CHANGE_REQUESTED) {
                      pBookingDet[i].flightGroup[0]["flightStatus"] = this.ADMIN_SIGNIN_RES ? this.$t('bookingDetail.newRefundReq'): 
                      this.$t('bookingDetail.refundReq');
                    }
                    else if(pBookingDet[i].flightGroup[0].segmentStatus == REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS) {
                      pBookingDet[i].flightGroup[0]["flightStatus"] = this.$t('bookingDetail.refundSuccess');
                    }
                    else if(pBookingDet[i].flightGroup[0].segmentStatus == REFUND_SEGMENT_STATUS.FULFILLED_FAILURE) {
                      pBookingDet[i].flightGroup[0]["flightStatus"] = this.$t('bookingDetail.refundFail');
                    }
                  }
              }
              if(pBookingDet[i].flightGroup[0].paxDetails){
                for (let j = 0; j < pBookingDet[i].flightGroup[0].paxDetails.length; j++) {
                  if(pBookingDet[i].flightGroup[0].paxDetails[j].type == BOOKING_ORDER_TYPE.BOOKING_ORDER){
                    if(pBookingDet[i].flightGroup[0].paxDetails[j].status == 1) {
                      pBookingDet[i].flightGroup[0].paxDetails[j]["paxStatus"] = null;
                    }
                  }
                  if(pBookingDet[i].flightGroup[0].paxDetails[j].type ==BOOKING_ORDER_TYPE.EXCHANGE){
                    if(pBookingDet[i].flightGroup[0].paxDetails[j].status == REFUND_SEGMENT_STATUS.CHANGE_REQUESTED) {
                      pBookingDet[i].flightGroup[0].paxDetails[j]["paxStatus"] =  this.ADMIN_SIGNIN_RES ? this.$t('bookingDetail.newExchangeReq'): this.$t('bookingDetail.exchangeReq');
                    }
                    else if(pBookingDet[i].flightGroup[0].paxDetails[j].status == REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS) {
                      pBookingDet[i].flightGroup[0].paxDetails[j]["paxStatus"] = this.$t('bookingDetail.exchangeSuccess');
                    }
                    else if(pBookingDet[i].flightGroup[0].paxDetails[j].status == REFUND_SEGMENT_STATUS.FULFILLED_FAILURE) {
                      pBookingDet[i].flightGroup[0].paxDetails[j]["paxStatus"] = this.$t('bookingDetail.exchangeFail');
                    }
                  }
                  if(pBookingDet[i].flightGroup[0].paxDetails[j].type == BOOKING_ORDER_TYPE.REFUND){
                    if(pBookingDet[i].flightGroup[0].paxDetails[j].status == REFUND_SEGMENT_STATUS.CHANGE_REQUESTED) {
                      pBookingDet[i].flightGroup[0].paxDetails[j]["paxStatus"] = this.ADMIN_SIGNIN_RES ? this.$t('bookingDetail.newRefundReq'): 
                      this.$t('bookingDetail.refundReq');
                    }
                    else if(pBookingDet[i].flightGroup[0].paxDetails[j].status == REFUND_SEGMENT_STATUS.FULFILLED_SUCCESS) {
                      pBookingDet[i].flightGroup[0].paxDetails[j]["paxStatus"] = this.$t('bookingDetail.refundSuccess');
                    }
                    else if(pBookingDet[i].flightGroup[0].paxDetails[j].status == REFUND_SEGMENT_STATUS.FULFILLED_FAILURE) {
                      pBookingDet[i].flightGroup[0].paxDetails[j]["paxStatus"] = this.$t('bookingDetail.refundFail');
                    }
                  }
                }

              }
              
            }
          }retValue=pBookingDet;
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.BOOKING_DETAILS,
                  "error in toGetStatusOfPax",
                  err.toString(),
                  "toGetStatusOfPax",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 

    getFlightListByGroup(pTicketDetail) {
      let flightGroupList = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getFlightListByGroup");
        if (
          pTicketDetail &&
          pTicketDetail.flights &&
          pTicketDetail.flights.length > 0
        ) {
          flightGroupList = GroupByList(
            pTicketDetail.flights,
            "id",
            "flightGroup"
          );
        }
        let paxList = []
        let frstKey = Object.keys(pTicketDetail.orderPassengerDetails)[0];
        if(pTicketDetail.orderPassengerDetails[frstKey].isLeadPax!=true) {
        for(var i in pTicketDetail.orderPassengerDetails) {
          pTicketDetail.orderPassengerDetails[i]['paxId'] = i;
          paxList.push(pTicketDetail.orderPassengerDetails[i]);
        }
        
        pTicketDetail.orderPassengerDetails = paxList.reverse()
        }else{
          for(var i in pTicketDetail.orderPassengerDetails) {
             pTicketDetail.orderPassengerDetails[i]['paxId'] = i;
          paxList.push(pTicketDetail.orderPassengerDetails[i]);
        }
          pTicketDetail.orderPassengerDetails = paxList
        }

        if (flightGroupList && flightGroupList.length > 0) {
          for (let index = 0; index < flightGroupList.length; index++) {
            const flight = flightGroupList[index];
            // flight.flightGroup.forEach(element => {
            //   element.flight.via = { text: "via" + index };
            // });
            flight.flightGroup.forEach(fInfo => {
              fInfo.flight.forEach(flightObj => { 
                
                if (pTicketDetail.airlines) {
                    let airlineObj = Object.values(pTicketDetail.airlines).find(
                      airline => airline.airline_code == flightObj.flight.opAirline
                    );

                    if (airlineObj) {
                      flightObj.flight.airline_name = airlineObj.airline_name;
                      flightObj.flight.logo_url = airlineObj.logourl;
                    }
                  }
                  if (pTicketDetail.airports) {
                    flightObj.flight.arrCity =
                      pTicketDetail.airports[flightObj.flight.ArrAirport].city;
                    flightObj.flight.depCity =
                      pTicketDetail.airports[flightObj.flight.DepAirport].city;
                  }
              })
                  
              });
          
            flight.pnr = pTicketDetail.flights[index].pnr;
            flight.showDet = false;
            flight.flightGroup = OrderBy(
              flight.flightGroup,
              "displayOrder",
              ORDER.ASC
            );
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_TICKETING_CONNECTION_FLIGHT,
          "error in getFlightListByGroup",
          err.toString(),
          "getFlightListByGroup",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return flightGroupList;
    },

    toGetSucessPayment(pBookingDet) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("toGetSucessPayment");
          if(pBookingDet && pBookingDet.orderPaymentDetails) {
          if(pBookingDet && pBookingDet.orderPaymentDetails && pBookingDet.orderPaymentDetails.length>1) {
            for (let i = 0; i < pBookingDet.orderPaymentDetails.length; i++) {
              if(pBookingDet.orderPaymentDetails[i].status == 10) {
                retValue = pBookingDet.orderPaymentDetails[i];
              }
              
            }
            if(!retValue){
              retValue = pBookingDet.orderPaymentDetails[pBookingDet.orderPaymentDetails.length-1]
            }
          }else{
            retValue = pBookingDet.orderPaymentDetails[0];
          }
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.BOOKING_DETAILS,
                  "error in toGetSucessPayment",
                  err.toString(),
                  "toGetSucessPayment",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 
    toCheckForFlightStatus(pBookingDet) {
      let retValue = false;
        try {
          if(BaseConfiguration.isDebug) console.log("toCheckForFlightStatus");

          if(!retValue && pBookingDet && pBookingDet.flights && pBookingDet.flights.length!=0) {
            loop1: for (let i = 0; i < pBookingDet.flights.length; i++) {
              if(pBookingDet.flights[i].paxDetails) {
               loop2: for (let j = 0; j < pBookingDet.flights[i].paxDetails.length; j++) {
                  if(pBookingDet.flights[i].paxDetails[j].status==2){
                    retValue = true;
                    break loop1;
                  }else{
                    retValue = false;
                  }
                  
                }
              }
              
            }
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.BOOKING_DETAILS,
                  "error in toCheckForFlightStatus",
                  err.toString(),
                  "toCheckForFlightStatus",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 
  },

  async created() {
    {
      try {
        if (BaseConfiguration.isDebug) console.log("created");

        // to show payment History for Refund and Exchange
        if(Router && Router.currentRoute && Router.currentRoute.query && Router.currentRoute.query[ROUTER_PARAM.BOOKING_ORDER_ID])
        {

          let ticketObj=Router.currentRoute.query;
               if(ticketObj.ph)
             this.showPaymentHistory=ticketObj.ph
            this.bookingDet = await this.getTicketingOrderDetails(ticketObj);
        }

        //existing booking Details  flow
        else{
          this.bookingDet = await this.getTicketingOrderDetails(this.ticketObj);
        }

    
        this.paymentDetails = this.toGetSucessPayment(this.bookingDet);
        this.isRequested = this.toCheckForFlightStatus(this.bookingDet);
        if (this.bookingDet) {
          let flightLs = this.getFlightListByGroup(this.bookingDet);
          flightLs= this.toGetStatusOfPax(flightLs);
          
          this.lsFlights = cloneDeep(flightLs);

        }
        this.isLoading=false;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.BOOKING_DETAILS,
          "error in created",
          err.toString(),
          "created",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },

  beforeCreate() {
    addClassToBody(COMPONENT_NAME.BOOKING_DETAILS);
  },

  beforeDestroy() {
    removeClassBody();
  }
};
</script>

<style>
.connectingRow.w-100 {
  margin-left: 0px;
}
</style>